<template>
  <acknowledge :headline="headline">
    <template slot="image">
      <img class="craft" alt="craft" src="../../assets/images/craft-category-icon.svg"/>
    </template>
    <template slot="message">
      <p>We're busy crafting your custom quote.<br/>
        Thank you for your interest in Lerner Maker Lab!</p>
    </template>
  </acknowledge>
</template>

<script>
  import Acknowledge from '@/component/Acknowledge';

  export default {
    name: 'RequestPricingAcknowledge',

    components: {
      Acknowledge
    },

    data: function () {
      return {
        headline: 'We got it!',
      }
    }
  };
</script>

<style lang="scss" scoped>
  img {
    max-width: 250px;
    @apply my-6;
  }

  button {
    @apply bg-lerner-blue text-white font-bold py-2 px-8 rounded-full;

    &:hover {
      background: lighten(#2d4c90, 10%);
    }
  }
</style>